export default "__VITE_ASSET__BAtBiSK5__"